<template lang="pug">
.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/account")
          i.fa.fa-users
          span.ml-1 {{ $t("title.accounts") }}
      b-breadcrumb-item
        router-link(to="/account/dailyMetrics")
          i.fa.fa-list-alt
          span.ml-1 {{ $t("title.daily_metrics") }}
  .row
    .col-md-12
      .form-row
        .col-xs-10.col-sm-6.col-md-4.col-lg-4.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.icon-user
            DebounceInput(
              type="search"
              v-model.trim.lazy="search_id"
              :placeholder="$t('ui.account_id')"
            )
        .col-xs-10.col-sm-6.col-md-3.col-lg-3.mb-1
          DateRangePicker(:title="$t('ui.date_range')" :value="dateRange" ref="dateRangePicker" :isDailyMetrics="true" notBefore="2024-03-11")
        .col-xs-2.col-sm-2.col-md-2.col-lg-2.mb-1
          SubmitButton(
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="submit"
            variant="success"
            size="sm"
          )

  //- Member
  .row(v-if="stats.detail.length > 0")
    .col-lg-6.col-md-6.col-sm-6
      .card.card-glass
        .card-header.p-2
          i.icon-people
          span.text-secondary {{ $t("ui.member") }}
        .card-body.p-2
          .table-responsive.mb-0(style="height: 225px;")
            table.table.b-table.c-table.glass-table.table-borderless(role="table", aria-busy="false")
              thead(role="rowgroup")
                tr(role="row")
                  th.text-left(role="columnheader", scope="col" style="width: 160px;")
                    div {{ $t("ui.description") }}
                  th.text-right(role="columnheader", scope="col")
                    div {{ $t("ui.total") }}
              tbody(role="rowgroup")
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalMember") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].mb_count ? stats.detail[0].mb_count: 0 }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalActiveMember") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].tran_count ? stats.detail[0].tran_count: 0 }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalMemberRegister") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].register_count ? stats.detail[0].register_count: 0 }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalMemberLogin") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].login_count ? stats.detail[0].login_count: 0 }}

    //- Deposit
    .col-lg-6.col-md-6.col-sm-6
      .card.card-glass
        .card-header.p-2
          i.fas.fa-money-bill
          span.text-secondary {{ $t("ui.deposit") }}
        .card-body.p-2
          .table-responsive.mb-0(style="height: 225px;")
            table.table.b-table.c-table.glass-table(role="table", aria-busy="false")
              thead(role="rowgroup")
                tr(role="row")
                  th.text-left(role="columnheader", scope="col" style="width: 160px;")
                    div {{ $t("ui.description") }}
                  th.text-right(role="columnheader", scope="col")
                    div {{ $t("ui.total") }}
              tbody(role="rowgroup")
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalDeposit") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].deposit_total | currency }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalDepositTransaction") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].deposit_count ? stats.detail[0].deposit_count: 0 }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalFirstDepositMember") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].deposit_first ? stats.detail[0].deposit_first: 0 }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.averageDeposit") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].deposit_average | currency }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.uniqueDepositMember") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].deposit_unique_count }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalAgentTransfer") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].deposit_ag_total | currency }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalAgentTransferTransaction") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].deposit_ag_count ? stats.detail[0].deposit_ag_count: 0 }}

  //- Withdrawal
  .row(v-if="stats.detail.length > 0")
    .col-lg-6.col-md-6.col-sm-6
      .card.card-glass
        .card-header.p-2
          i.fas.fa-money-bill-wave
          span.text-secondary {{ $t("ui.withdrawal") }}
        .card-body.p-2
          .table-responsive.mb-0(style="height: 225px;")
            table.table.b-table.c-table.glass-table(role="table", aria-busy="false")
              thead(role="rowgroup")
                tr(role="row")
                  th.text-left(role="columnheader", scope="col" style="width: 160px;")
                    div {{ $t("ui.description") }}
                  th.text-right(role="columnheader", scope="col")
                    div {{ $t("ui.total") }}
              tbody(role="rowgroup")
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalWithdrawal") }}
                  td(role="cell")
                    .text-right
                      span(:class="{ 'text-danger' : stats.detail[0].withdraw_total < 0 }") {{ stats.detail[0].withdraw_total | currency }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalWithdrawalTransaction") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].withdraw_count ? stats.detail[0].withdraw_count: 0 }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalFirstWithdrawalMember") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].withdraw_first ? stats.detail[0].withdraw_first: 0 }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.averageWithdrawal") }}
                  td(role="cell")
                    .text-right
                      span(:class="{ 'text-danger' : stats.detail[0].withdraw_average < 0 }") {{ stats.detail[0].withdraw_average | currency }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.uniqueWithdrawalMember") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].withdraw_unique_count }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalAgentWithdrawal") }}
                  td(role="cell")
                    .text-right
                      span(:class="{ 'text-danger' : stats.detail[0].withdraw_ag_total < 0 }") {{ stats.detail[0].withdraw_ag_total | currency }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalAgentWithdrawalTransaction") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].withdraw_ag_count ? stats.detail[0].withdraw_ag_count: 0 }}

    //- Adjustment
    .col-lg-6.col-md-6.col-sm-6
      .card.card-glass
        .card-header.p-2
          i.fas.fa-money-check-alt
          span.text-secondary {{ $t("ui.adjustment") }}
        .card-body.p-2
          .table-responsive.mb-0(style="height: 225px;")
            table.table.b-table.c-table.glass-table(role="table", aria-busy="false")
              thead(role="rowgroup")
                tr(role="row")
                  th.text-left(role="columnheader", scope="col" style="width: 160px;")
                    div {{ $t("ui.description") }}
                  th.text-right(role="columnheader", scope="col")
                    div {{ $t("ui.total") }}
              tbody(role="rowgroup")
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalAdjustment") }}
                  td(role="cell")
                    .text-right
                      span(:class="{ 'text-danger' : stats.detail[0].adjust_total < 0 }") {{ stats.detail[0].adjust_total | currency }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.totalAdjustmentMember") }}
                  td(role="cell")
                    .text-right
                      span {{ stats.detail[0].adjust_count ? stats.detail[0].adjust_count: 0 }}
                tr(role="row")
                  td(role="cell")
                    .text-left
                      span {{ $t("ui.averageAdjustment") }}
                  td(role="cell")
                    .text-right
                      span(:class="{ 'text-danger' : stats.detail[0].adjust_average < 0 }") {{ stats.detail[0].adjust_average | currency }}

  #end-report.mt-3

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

import DateRangePicker from "@/library/DateRangePicker.vue";
import DebounceInput from "@/library/DebounceInput";
import ValidateResult from "@/library/ValidateResult";
import SubmitButton from "@/library/SubmitButton.vue";
import currency from "@/components/currency.vue";

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    DateRangePicker,
    currency
  },
  data() {
    return {
      search_id: "",
      stats: {
        detail: []
      }
    };
  },
  validations: {},
  computed: {
    dateRange(e) {
      var startDate = this.$store.getters.dateRange[0];
      var endDate = this.$store.getters.dateRange[1];
      if(startDate < this.$moment(new Date('2024-03-11')))
        startDate = this.$moment(new Date('2024-03-11'))

      if(endDate > this.$moment().endOf("day").toDate())
        endDate = this.$moment().endOf("day").toDate()

      return [startDate, endDate];
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    submit() {
      this.getList();
    },
    getList() {
      this.stats = {
        detail: []
      };
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
      };
      args["target_account_id"] = this.search_id || null;
      args["start_date"] = this.dateRange[0] != null ? (this.dateRange[0] != "" ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
      args["end_date"] = this.dateRange[1] != null ? (this.dateRange[1] != "" ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";

      xhr
        .doRequest(args, xhr.ACCOUNT.dailyCount)
        .then(res => {
          this.stats = res.data;
        })
        .catch(res => {
          this.$helpers.handleFeedback(res.status);
        });
    }
  }
};
</script>
